import { useState, type JSX } from 'react';
import { useApp, type Screen } from '../state/app.js';
import { useIsMobile } from '../lib/useIsMobile.js';
import { MyProfileModal } from '../modals/MyProfileModal.js';
import { HelpLayer } from '../ui/HelpLayer.js';
import { Avatar } from '../ui/common.js';

// 상단 화면 제목 — Screen 전체를 키로 강제(새 화면 추가 시 누락되면 컴파일 오류)
const TITLES: Record<Screen, string> = {
  home: '개인 메인',
  board: '임직원 보드',
  leave: '휴가 관리',
  trip: '출장 관리',
  overtime: '야근',
  weekly: '주간 업무 보고',
  expense: '경비 지출 관리',
  company: '회사 정보',
  ci: 'CI',
  resources: '문서함',
  library: '자료실',
  picker: '랜덤피커',
  admin: '근무현황',
  approve: '휴가 승인',
  stats: '근무통계분석',
  peopleStats: '임직원통계분석',
  settings: '관리자 설정',
};

export function Topbar(): JSX.Element {
  const { me, env, screen } = useApp();
  const isMobile = useIsMobile();
  const [profileOpen, setProfileOpen] = useState(false);
  const [helpOpen, setHelpOpen] = useState(false);
  // 사이드바가 없는 화면(휴대폰·Outlook 사이드 창)에서는 내 정보 진입을 상단에 유지
  const hasSidebar = env !== 'pane' && !isMobile;

  return (
    <div style={{ flexShrink: 0, background: '#fff', borderBottom: '1px solid #E5E7EB', padding: '12px 18px', display: 'flex', alignItems: 'center', gap: 12 }}>
      {(env === 'pane' || isMobile) && <img src="/brand/DXTECH_MARK.svg" alt="DXTECH" style={{ width: 24, height: 24 }} />}
      <div style={{ minWidth: 0 }}>
        <div style={{ fontSize: 12, color: '#9CA3AF' }}>{new Intl.DateTimeFormat('ko-KR', { timeZone: 'Asia/Seoul', month: 'long', day: 'numeric', weekday: 'long' }).format(new Date())}</div>
        <div style={{ fontSize: 17, fontWeight: 700, letterSpacing: '-.01em', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {TITLES[screen]}
        </div>
      </div>
      <span style={{ marginLeft: 'auto', display: 'inline-flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
        <button className="dx-help-btn" onClick={() => setHelpOpen(true)} aria-expanded={helpOpen} aria-label={`${TITLES[screen]} 도움말`} title="이 화면 도움말">?</button>
        {!hasSidebar && (
          <button onClick={() => setProfileOpen(true)} title="내 정보 수정 (생일·주소·연락처)" aria-label="내 정보"
            style={{ border: 'none', background: 'transparent', padding: 0, borderRadius: '50%', cursor: 'pointer', lineHeight: 0 }}>
            <Avatar name={me.name} upn={me.upn} size={32} />
          </button>
        )}
      </span>
      {helpOpen && <HelpLayer screen={screen} title={TITLES[screen]} onClose={() => setHelpOpen(false)} />}
      {profileOpen && <MyProfileModal onClose={() => setProfileOpen(false)} />}
    </div>
  );
}
